module.exports = __webpack_public_path__ + "static/media/vincent-versluis.dfda1541.jpg";